import { render, staticRenderFns } from "./CompetenceUnits.vue?vue&type=template&id=19b437b2&scoped=true"
import script from "./CompetenceUnits.vue?vue&type=script&lang=js"
export * from "./CompetenceUnits.vue?vue&type=script&lang=js"
import style0 from "./CompetenceUnits.vue?vue&type=style&index=0&id=19b437b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b437b2",
  null
  
)

export default component.exports